<template>
  <b-container class="d-flex flex-column justify-content-center">
    <b-row>
      <b-col>
        <b-alert :variant="autorizacao.atual ? 'primary' : 'danger'" show>
          <b-container v-if="autorizacao">
            <b-row>
              <b-col class="d-flex justify-content-center h1"
                >Evento: {{ autorizacao.descricao }}. Horário:
                {{ autorizacao.horainicio }} às {{ autorizacao.horafim }}</b-col
              >
            </b-row>
            <b-row>
              <b-col class="d-flex justify-content-center h4">
                {{
                  autorizacao.atual
                    ? "Tempo para terminar refeição: "
                    : "Tempo para iniciar próxima refeição: "
                }}
                <vue-countdown-timer
                  :start-time="new Date()"
                  :end-time="horaTerminoRefeicao"
                  :interval="1000"
                  :day-txt="null"
                  hour-txt="h"
                  minutes-txt="min"
                  seconds-txt="seg"
                  @end_callback="buscaAutorizacaoAtual"
                />
              </b-col>
            </b-row>
          </b-container>
          <b-container v-else>
            <b-row>
              <b-col class="d-flex justify-content-center h1"
                >Não há mais eventos para hoje.</b-col
              >
            </b-row>
          </b-container>
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        ><b-alert
          :show="dismissCountDown"
          @dismiss-count-down="countDownChanged"
          :variant="
            resposta_autorizacao && resposta_autorizacao.success
              ? 'success'
              : 'danger'
          "
        >
          <b-row>
            <b-col class="d-flex justify-content-center h2">{{
              resposta_autorizacao ? resposta_autorizacao.message : null
            }}</b-col>
          </b-row>
          <b-row
            v-show="
              resposta_autorizacao && resposta_autorizacao.refeicao_acompanhante
            "
          >
            <b-col class="h4">
              <b-row>
                <b-col class="d-flex justify-content-end">
                  Nome:
                </b-col>
                <b-col>
                  {{
                    resposta_autorizacao &&
                    resposta_autorizacao.dados_acompanhante
                      ? resposta_autorizacao.dados_acompanhante.nome
                      : null
                  }}
                </b-col>
              </b-row>
              <b-row>
                <b-col class="d-flex justify-content-end">
                  RG:
                </b-col>
                <b-col>
                  {{
                    resposta_autorizacao &&
                    resposta_autorizacao.dados_acompanhante
                      ? resposta_autorizacao.dados_acompanhante.rg
                      : null
                  }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row
            v-show="
              resposta_autorizacao && resposta_autorizacao.refeicao_colaborador
            "
          >
            <b-col class="h4">
              <b-row>
                <b-col class="d-flex justify-content-end">
                  Nome:
                </b-col>
                <b-col>
                  {{
                    resposta_autorizacao &&
                    resposta_autorizacao.dados_colaborador
                      ? resposta_autorizacao.dados_colaborador.nome
                      : null
                  }}
                </b-col>
              </b-row>
              <b-row>
                <b-col class="d-flex justify-content-end">
                  Ocupação:
                </b-col>
                <b-col>
                  {{
                    resposta_autorizacao &&
                    resposta_autorizacao.dados_colaborador
                      ? resposta_autorizacao.dados_colaborador.ocupacao
                      : null
                  }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-alert></b-col
      >
    </b-row>

    <b-row v-if="!configuracao_bloqueio_entrada_mural" class="d-flex justify-content-center">
      <b-col class="col-sm-12 col-md-6 col-lg-6">
        <b-form-input
          id="cracha_input"
          size="lg"
          placeholder="CRACHÁ OU CPF"
          :disabled="(autorizacao.atual ? false : true) || isButtonDisabled"
          v-model.trim="num_cracha_string"
          @keyup.enter="registraEntrada"
          ref="cracha"
        ></b-form-input>
        <b-button
          variant="success"
          class="mt-2"
          block
          @click="registraEntrada"
          :disabled="(autorizacao.atual ? false : true) || isButtonDisabled"
          >Buscar</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment"
import io from "socket.io-client"

export default {
  data() {
    return {
      autorizacao: {},
      num_cracha_string: "",
      resposta_autorizacao: null,
      dismissSecs: 15,
      isButtonDisabled: false,
      dismissCountDown: 0,
      configuracao_bloqueio_entrada_mural: true,
      io: null
    };
  },
  computed: {
    horaTerminoRefeicao() {
      if (this.autorizacao.atual)
        return moment().format("YYYY-MM-DD") + " " + this.autorizacao.horafim;
      else
        return (
          moment().format("YYYY-MM-DD") + " " + this.autorizacao.horainicio
        );
    },
  },
  methods: {
    buscaAutorizacaoAtual() {
      this.$http("/mural/buscaautorizacaoatual").then((response) => {
        this.autorizacao = response.data;
      });
    },
    registraEntrada() {
      if (this.num_cracha_string == "" || this.num_cracha_string ==  null ) {
        return;
      }
      this.isButtonDisabled = true;
      this.$http
        .post("/mural/registraentrada", {
          num_cracha_string: this.num_cracha_string,
          request_do_mural: true
        })
        .then((response) => {
          this.resposta_autorizacao = response.data;
          this.dismissCountDown = this.dismissSecs;
          this.num_cracha_string = null;
          this.isButtonDisabled = false;
          // nextTick é pra ele não tentar dar focus no botão desabilitado
          this.$nextTick(()=>{
            this.$refs.cracha.focus();
          })     
        });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
  },
  mounted(){
    this.io = io(process.env.VUE_APP_SOCKET_URL, {
      path: process.env.VUE_APP_SOCKET_PATH
    })
    console.log(this.io, process.env.VUE_APP_SOCKET_URL, process.env.VUE_APP_SOCKET_PATH)
    

    this.io.on('tentativaentrada', (msg) => {
      console.log(msg)
      this.resposta_autorizacao = msg
      this.dismissCountDown = this.dismissSecs;
    })


    this.$http.get("/configuracoes/8").then((c) => {
      if ( c.data ){
        this.configuracao_bloqueio_entrada_mural = c.data.ativa;
        console.log(c.data)
        console.log(this.configuracao_bloqueio_entrada_mural)
      }
    })	

  },
  created() {
    this.buscaAutorizacaoAtual();
  },
};
</script>

<style></style>
